import styled from "styled-components";
import Slider from "react-slick";

export const CustomSlider = styled(Slider)`
  margin-top: 0.65rem;

  .slick-prev,
  .slick-next {
    width: 34px;
    height: 34px;
    z-index: 2;
    border-radius: 999px;
    background: rgba(10, 10, 10, 0.08);
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .slick-next:before {
    color: ${({ theme }) => theme.colors.darkBackground} !important;
    font-size: 24px;
  }

  .slick-prev:before {
    color: ${({ theme }) => theme.colors.darkBackground} !important;
    font-size: 24px;
  }

  .slick-next {
    right: -14px;
  }

  .slick-prev {
    left: -14px;
  }

  .slick-dots {
    bottom: -28px;
  }

  .slick-dots li button:before {
    color: ${({ theme }) => theme.colors.primary};
    opacity: 0.45;
  }

  .slick-dots li.slick-active button:before {
    opacity: 1;
  }
`;

export const MachineryContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding: 2rem 1.25rem 2.6rem;
  background: linear-gradient(180deg, #f8f8f8 0%, #eff4df 100%);
`;

export const MachineryWrapper = styled.div`
  width: 100%;
  height: 100%;
  justify-content: center;
  text-align: center;
  display: flex;
`;

export const MachineryInformationWrapper = styled.div`
  width: min(1020px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const MachineryInformation = styled.button`
  position: relative;
  width: 100%;
  min-height: 245px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  cursor: pointer;
  border: none;
  border-radius: 14px;
  padding: 1rem;
  background-image: linear-gradient(165deg, rgba(10, 10, 10, 0.25), rgba(10, 10, 10, 0.6)), url(${(props) => props.background});
  background-size: cover;
  background-position: center;
  transition:
    transform 0.22s ease,
    box-shadow 0.22s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 28px rgba(10, 10, 10, 0.22);
  }

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    min-height: 210px;
  }
`;

export const MachineryTileOverlay = styled.div`
  text-align: left;
  z-index: 1;
`;

export const MachineryTitle = styled.h1`
  width: 100%;
  margin: 0 auto 1.2rem;
  text-align: center;
  position: relative;
  z-index: 2;
`;

export const TriangleText = styled.div`
  color: #ffffff;
  z-index: 1;
  text-align: left;
  font-size: 1.6rem;
  line-height: 1;
  font-weight: 800;
`;

export const MachinerySubtitle = styled.p`
  margin: 0.45rem 0 0;
  color: #e6edd8;
  font-size: 0.93rem;
  font-weight: 500;
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.62);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
`;

export const ModalCard = styled.div`
  background: #ffffff;
  padding: 1.1rem;
  border-radius: 14px;
  text-align: center;
  position: relative;
  box-shadow: 0 20px 44px rgba(0, 0, 0, 0.24);
  width: ${({ $isMobile }) => ($isMobile ? "100%" : "min(640px, 96%)")};
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(10, 10, 10, 0.05);
  border: none;
  border-radius: 999px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: pointer;

  &:hover {
    background: rgba(10, 10, 10, 0.1);
  }
`;

export const ModalTitle = styled.h2`
  margin: 0.2rem 0 0;
  font-size: 1.7rem;
  color: ${({ theme }) => theme.colors.darkBackground};
`;

export const ModalSlideCount = styled.p`
  margin: 0.45rem 0 0;
  font-size: 0.85rem;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text};
`;

export const ModalDescription = styled.p`
  margin: 1.2rem auto 0;
  width: min(92%, 560px);
  line-height: 1.75;
  color: ${({ theme }) => theme.colors.text};
`;
